<template>
	<div class="mb-5 mx-5 mt-3 ResponsiveControlePage">
		<div class="mb-2">
			<breadCrumbs :routesArray="routesArray"></breadCrumbs>
		</div>
		<div class="items-center justify-between flex">
			<div v-if="!(presentSubTask.TaskName)" class="title flex items-center">
				<h1 :class="presentSubTask?.controlDetails != undefined && presentSubTask?.presentSubTask?.controlDetails?.[0]?.controlTitle.length > 40 ? 'heading-ellipsis':''">{{presentSubTask?.controlDetails?.[0]?.controlTitle||'N/A' }}</h1>
				<!-- <h1 class="title">{{ controltitle.controlTitle }}</h1> -->
			</div>
			<div v-else class="title flex items-center">
				  <h1 :class="presentSubTask.TaskName!=undefined && presentSubTask.TaskName!='' && presentSubTask.TaskName.length > 0 > 40? 'heading-ellipsis':''">{{ presentSubTask.TaskName }}</h1>
				<!-- <h1 class="title">{{ presentSubTask.TaskName }}</h1> -->
			</div>
			<div class="flex">
				
				<div v-if="checkOwner() && (presentSubTask.statusCode == 10415)">
					<!-- v-if="checkOwner() && presentSubTask.statusCode == 10402" -->
					<button class="btnprimary mr-1.5" :disabled="clickOnButton" @click="approveOrRejectTheParentApproval(10403)">Approve</button>
					<button class="btnprimary mr-1.5" :disabled="clickOnButton" @click="approveOrRejectTheParentApproval(10410)">Reject</button>
				</div>
				
				
			</div>
		</div>
		
		<div>
			<div class="w-full minheight">
				<div class="w-full">
					<div class="text-sm">
						<div class="mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey">
							<Tabs  v-model:value="selectedTabIndex" scrollable class="w-80 heightFixing pr-5">
								<div>
									<TabList >
										<Tab  v-for="(tab, tabIndex) in tabHead" :key="tabIndex" :value="tab.id" @click="toggleTabs(tab)">
											{{ tab.displayName }}
										</Tab>
									</TabList>
								</div>
								<TabPanels class="overflow-auto hide-scrollbar">
									<TabPanel v-for="(tab,tabIndex) in tabHead" :key="tabIndex" :value="tab.id">
										<div v-if="dotsLoader == true">
											<div class="flex items-center justify-center w-full h-16 skeleton">
												<dotsloader/>
											</div>
										</div>
										<div v-else>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1">
												<div class="flex">
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">CID</p>
														<p v-if="(linkedControlDetails[0]?.clientUniqueId||'N/A')" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.clientUniqueId ||'N/A'}}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">Frequency</p>
														<p v-if="(presentSubTask?.controlFrequency||'N/A')" class="mt-1 mb-3 text-sm">{{getControlFrequency(presentSubTask?.controlFrequency)||'N/A'}}</p>
														<p class="text-sm mt-1 mb-3" v-else>N/A</p>
													</div>
													
												</div>

												<div class="flex">
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Title</p>
														<p v-if="(linkedControlDetails[0]?.controlTitle)" class="mt-1 text-sm">{{ linkedControlDetails[0]?.controlTitle||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Type</p>
														<p v-if="(linkedControlDetails[0]?.controlType)" class="mt-1 text-sm">{{ linkedControlDetails[0]?.controlType||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
												</div>
												<div class="flex flex-row mt-3"> 
													<div class="w-6/12">
														<label class="font-extrabold text-xs">Priority</label>
														<div v-if="linkedControlDetails[0]?.controlPriority && typeof linkedControlDetails[0]?.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(linkedControlDetails[0]?.controlPriority)">
															<div class="text-xs" :class="colorLabelText(linkedControlDetails[0]?.controlPriority)">
															{{ getProirityLabel(linkedControlDetails[0]?.controlPriority) }}
															</div>
														</div>
														<div v-else class="text-sm mt-2">N/A</div>
													</div>
													
												</div> 
												<div class="flex">
													<div class="w-6/12">
														<p class="font-extrabold mt-2 mb-1 text-xs">Class</p>
														<p v-if="(linkedControlDetails[0]?.controlClass)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlClass||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mt-2 mb-1 text-xs">Family</p>
														<p v-if="(linkedControlDetails[0]?.controlFamily)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlFamily||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>

												</div>
												<div> 
													<label class="font-extrabold mt-2 text-xs">Description</label>
													<p v-if="(linkedControlDetails[0]?.Description)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.Description||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div> 
													<label class="font-extrabold mt-2 text-xs">Policy/Procedure</label>
													<p v-if="(linkedControlDetails[0]?.controlPolicies)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlPolicies||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div>
													<label class="font-extrabold mt-2 mb-1 text-xs">Guidance</label>
													<p v-if="(linkedControlDetails[0]?.controlGuidance)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlGuidance||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div> 
													<label class="font-extrabold mt-2 mb-1  text-xs">Task</label>
													<p v-if="(linkedControlDetails[0]?.controlMaintenanceTask)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlMaintenanceTask||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<!-- <div class="mb-2">
													{{ presentSubTask.description }}
												</div> -->
												<div v-if="presentSubTask.notes">
													<div>
															<p class="mt-2 mb-1 header">Notes</p>
														<p class="mt-1 mb-4">{{ presentSubTask.notes }}</p>
													</div>
													<!-- <div class="mb-2">
														{{ presentSubTask.notes }}
													</div> -->
												</div>
												
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 2">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<!-- <div class="flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center"> -->
															<div>
																<p class="my-2 header">Documents</p>
															</div>
														<!-- </div> -->
														<div class="buttonposition flex justify-center items-center mb-1.5">
															<!-- <button class=" btnprimary flex justify-center taskEditButtons">Attach</button> -->
														</div>
													</div>
													
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 3">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<div class="flex items-center justify-center">
															<div>
																<p class="my-1 header">Evidence</p>
															</div>
														</div>
														<div>
															<div
															class="buttonposition flex justify-center items-center sendapprovalheight"
															>
																<div
																	class="buttonposition flex justify-center items-center"
																>
																	<button @click="openFilePopup" for="upload"  :class="(presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420)|| isAddDisabled(10302)? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'">Attach</button>
																</div>
															</div>
														</div>
													</div>
													<!-- <p class="mt-1.5">Files</p> -->
													<div v-if="Object.keys(presentSubTask).includes('evidences')" class="flex mt-4 gap-4 flex-wrap">
														<div v-for="(doc, evidenceIndex) in presentSubTask.evidences" :key="evidenceIndex">
															<div class="pdf w-full rounded-sm">
																<a
																	:href="sanitizeUrl(doc.url)"
																	target="_blank"
																	rel="noopener noreferrer"
																	class="flex w-full flex-row items-center"
																>
																	<img src="@/assets/pdfs.svg" alt="" />
																	<p v-if="Object.keys(doc).includes('filename')" class="text-xs ml-2">{{doc.filename}}</p>
																	<p v-else class="text-xs ml-1">{{ doc.name }}</p>
																	<img src="@/assets/deleteIcon.svg" alt="" @click.stop.prevent="removeEvidence(evidenceIndex)" :class="(presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420)|| isAddDisabled(10302)? 'h-5 w-5 pointer-events-none ml-auto' : 'h-5 w-5 cursor-pointer ml-auto'" />
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 5">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<div class="flex items-center justify-center">
															<div>
																<p class="my-2.5 header">Comments</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center sendapprovalheight">
																<!-- <div class="buttonposition flex justify-center items-center"> -->
																	<button class="btnprimary flex taskEditButtons" v-if="!oldComments" @click="sortComments()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2" />
																		Newest
																	</button>
																	<button class="btnprimary flex taskEditButtons" v-if="oldComments" @click="sortComments()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2 rotate-180" />
																		Oldest
																	</button>
																<!-- </div> -->
															</div>
														</div>
													</div>
													<div>
														<div class="comment-box w-full">
															<!-- <div class="my-3"><textarea placeholder="Add a Comment" class="w-full text-xs border border-lightgrey rounded-sm p-2" rows="4" :disabled="presentSubTask.statusCode == 10403"  v-model="comment" @input="handleInput"></textarea></div>
															<div class="flex justify-end">
																<button @click="addComment" class="mr-2" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Add</button>
																<button @click="clearComment" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Cancel</button>
															</div> -->
															<div class="my-3">
																<commentsEditor v-if="TaskDetailsDropDown.taskStatus!=10403&&TaskDetailsDropDown.taskStatus!=10401&&TaskDetailsDropDown.taskStatus!=10420 && !isAddDisabled(10302)"/>
															</div>
															
														</div>
														<div v-if="Object.keys(presentSubTask).includes('comments')" class="comments">
															<div v-for="(obj, index) in presentSubTask.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-2" :key="index">
																<div class="initials">{{extractInitials((obj.name) )}}</div>
																<div clas="w-1/5">
																	<div class="header">{{(obj.name) }}</div>
																	<div class="fontSize10PX">{{formatTime( obj.createdAt )}}</div>
																</div>
																<div class="w-4/5 text-xs"><safeHtml :content="obj.comment"/></div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 4">
												<div class="border-b border-lightgrey flex justify-between">
													<div class="flex items-center justify-center">
														<div>
															<p class="header">Approvals</p>
														</div>
													</div>
													<div>
														<div
														class="buttonposition flex justify-center items-center sendapprovalheight"
														>
															<div
																class="buttonposition flex justify-center items-center"
															>
																<button @click="openApprovalpopup()" :class="presentSubTask.statusCode==10403 || presentSubTask.statusCode==10415 || presentSubTask.statusCode==10420|| isAddApprovalDisabled(10302)?'approvalbtndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'" >
																Send Approval
																</button>
															</div>
														</div>
													</div>
												</div>
												<div>
													<div v-for="(approval, number) in presentSubTask.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
														<div v-if="approval.createdBy != undefined && !approval.updatedBy" class="initials">{{extractInitials((approval.name))}}</div>
														<div v-if="approval.createdBy != undefined && !approval.updatedBy" class="font-semibold mt-1 text-xs">{{ (approval.name) }}</div>
														
														<div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials((approval.name))}}</div>
														<div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ (approval.name) }}</div>

														<div v-if="approval.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
														<div v-else-if="approval.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
														<div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>
														<div v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.createdAt)}}</div>
														<div v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.updatedAt)}}</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 6">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<div class="flex items-center justify-between">
															<div>
																<p class="header">History</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center sendapprovalheight">
																<div class="buttonposition flex justify-center items-center">
																	<button class="btnprimary flex taskEditButtons" v-if="!newHistory" @click="sortWorkLog()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2" />
																		Newest
																	</button>
																	<button class="btnprimary flex taskEditButtons" v-if="newHistory" @click="sortWorkLog()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2 rotate-180" />
																		Oldest
																	</button>
																</div>
															</div>
														</div>
													</div>

												<div v-for="work in workLogObject.taskHistory" :key="work" class="bg-white p-4 mb-0.5 border-lightgrey border-b w-full">
														<div class="flex">
															<div v-if="Object.keys(work).includes('createdBy')" class="initials">
																{{ extractInitials((work.name)) }}
															</div>
															<div v-if="Object.keys(work).includes('updatedBy')" class="initials">
																{{ extractInitials((work.name)) }}
															</div>
															<!-- <div class="flex ml-4" v-if="Object.keys(work).includes('previousStatus')">
																
																<div class="">
																	
																	<div class="flex mt-3">
																		<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.previousStatus)">
																			<div :class="colorTemplateText(work.previousStatus)">
																				{{ getStatusLabel(work.previousStatus) }}
																			</div>
																		</div>
																		<div class="mx-4 flex items-center w-3.5"><img src="@/assets/arrowRight.svg"/></div>
																		<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.updatedStatus)">
																			<div :class="colorTemplateText(work.updatedStatus)">
																				{{ getStatusLabel(work.updatedStatus) }}
																			</div>
																		</div>
																	</div>
																</div>
															</div> -->
															<div class="logContainer w-93">
																<div class="flex mt-1">
																	<p v-if="Object.keys(work).includes('createdBy')" class="font-semibold text-xs">
																		{{ (work.name) }}
																	</p>
																	<p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold text-xs">
																		{{ (work.name) }}
																	</p>
			
																	<p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Task on' }}</p>
																	<p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 text-xs">{{ 'Terminated the Task on' }}</p>
																	<p v-else-if="work.actionEntity == 10302" class="mx-2 text-xs">{{ 'Updated the Task on' }}</p>
			
																	<p v-if="Object.keys(work).includes('createdAt')" class="font-semibold  text-xs">{{ formatTime(work.createdAt) }}</p>
																	<p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold text-xs">{{ formatTime(work.updatedAt) }}</p>
																</div>
																
																<div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('comment')">
																		<p class="font-semibold text-xs widthForCommentBox">{{ 'Comment :' }}</p>
																		<p class="text-xs w-full text-justify"><safeHtml :content="work.additionalInfo.comment"/></p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('dateId')">
																		<p class="font-normal text-xs">{{'Updated the '}}</p>
																		<p v-if="work.additionalInfo.dateId==20606" class="font-normal text-xs ml-2">{{' Completion Date from'}}</p>
																				<p v-else-if="work.additionalInfo.dateId==20604" class="font-normal text-xs ml-2">{{' Start Date from'}}</p>
																					<p v-else-if="work.additionalInfo.dateId==20605" class="font-normal text-xs ml-2">{{' dueDate from'}}</p>
																				<p v-if="work.additionalInfo.previousCompletionDate!='' && work.additionalInfo.dateId==20606" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousCompletionDate)}}</p>
																				<p v-else-if="work.additionalInfo.previousStartDate!='' && work.additionalInfo.dateId==20604" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousStartDate)}}</p>
																				<p v-else-if="work.additionalInfo.previousEndDate!='' && work.additionalInfo.dateId==20605" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousEndDate)}}</p>
																				<p v-else  class="font-semibold text-xs ml-2">N/A</p>
																				<p class="mx-2 font-normal text-xs">{{ 'to' }}</p>
																				
																				<p v-if="work.additionalInfo.updatedCompletionDate!=''&& work.additionalInfo.dateId==20606" class="font-semibold text-xs">{{formatDate(work.additionalInfo.updatedCompletionDate) }}</p>
																				<p v-else-if="work.additionalInfo.updatedStartDate!=''&& work.additionalInfo.dateId==20604" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.updatedStartDate)}}</p>
																				<p v-else-if="work.additionalInfo.updatedEndDate!='' && work.additionalInfo.dateId==20605" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.updatedEndDate)}}</p>
																				<p v-else class="font-semibold text-xs">N/A</p>
																	</div>
																	
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('filename')">
																		<p class="font-semibold text-xs">{{'Uploaded the Evidence -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.filename }}</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
																		<p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
																		<p class="mx-2 text-xs">{{ (work.additionalInfo.name) }}</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
																		<p  v-if="Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action==10301" class="font-semibold text-xs">{{'Requested approval from -'}}</p>
																		<p  v-else-if="!Object.keys(work).includes('action')" class="font-semibold text-xs">{{'Request approved By -'}}</p>
																		<p class="mx-2 text-xs text-justify">{{ (work.additionalInfo.name) }}</p>
																	</div>
																	<div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
																		<div>
																			<p class="font-semibold text-xs">{{'Updated The Status :'}}</p>
																		</div>
																		<div class="flex ml-4">
																			<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.additionalInfo.previousStatus)">
																				<div :class="colorTemplateText(work.additionalInfo.previousStatus)">
																					{{ getStatusLabel(work.additionalInfo.previousStatus) }}
																				</div>
																			</div>
																			<div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
																			<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.additionalInfo.updatedStatus)">
																				<div :class="colorTemplateText(work.additionalInfo.updatedStatus)">
																					{{ getStatusLabel(work.additionalInfo.updatedStatus) }}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</TabPanel>
								</TabPanels>
							</Tabs>
							<div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
								<div class="m-3">
									<div class="pb-2 border-b border-lightgrey">
										<h1>Task Details</h1>
									</div>
									<div v-if="dotsLoader == true">
										<div class="flex items-center justify-center w-full h-16 skeleton">
											<dotsloader/>
										</div>
									</div>
									<div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
										<div class="flex flex-col mb-3">
											<label class="controllabel">Task Status</label>
											<!-- :class="changeBackground()" -->
											<div v-if="(presentSubTask.statusCode == 10403 )" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														SubTaskStatus1.find((data)=>{
															return data.id == presentSubTask.statusCode
														}).value
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10420 )" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														failed.find((data)=>{
															return data.id == presentSubTask.statusCode
														}).value
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10415 )" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														inreview.find((data)=>{
															return data.id == presentSubTask.statusCode
														}).value
													}}
												</div>
											</div>
											<div v-else>
												<!-- <select
													class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
													:class="changeBackground()"
													v-if="(presentSubTask.statusCode != 10402)"
													:disabled="presentSubTask.statusCode == 10403"
													v-model="TaskDetailsDropDown.taskStatus"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												>
													<option value="" selected disabled hidden>Please select one</option>
													<option v-for="i in SubTaskStatus" :value="i.id" :key="i">
														{{ i.value }}
													</option>
												</select> -->
												<Select
												v-model="TaskDetailsDropDown.taskStatus"
												:options="SubTaskStatus"
												v-if="(presentSubTask.statusCode != 10402)"
												:disabled="presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420 || isAddDisabled(10302)"
												@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												optionLabel="value"
												optionValue="id"
												class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
												:class="changeBackground()"

												/>
												<!-- <select
													class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
													:class="changeBackground()"
													:disabled="presentSubTask.statusCode == 10403"
													v-else
													v-model="TaskDetailsDropDown.taskStatus"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												>
													<option value="" selected disabled hidden>Please select one</option>
													<option v-for="i in SubTaskStatus1" :value="i.id" :key="i">
														{{ i.value }}
													</option>
												</select> -->
												<Select
												v-model="TaskDetailsDropDown.taskStatus"
												:options="SubTaskStatus1"
												v-else
												:disabled="presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420 || isAddDisabled(10302)"
												@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												optionLabel="value"
												optionValue="id"
												class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
												:class="changeBackground()"
												/>
											</div>
											
										</div>
			
										
										<div class="mb-3">
											<div>
												<label class="controllabel">Assigned To</label>
												<!-- <div class="mt-2" v-if="presentSubTask.statusCode == 10403 || (presentSubTask.createdBy == userInfo._id && presentSubTask.assignee != undefined && presentSubTask.assignee.value != userInfo._id)">
													{{presentSubTask.assignee != undefined ? presentSubTask.assignee.label : 'N/A'}}
												</div> -->
												<div>
													<!-- <multiselect
														v-model="presentSubTask.assignee"
														:options="userOptions"
														:showNoOptions="false"
														@search-change="asyncFind"
														:limit-text="limitText"
														:multiple="false"
														:close-on-select="true"
														:disabled="presentSubTask.statusCode == 10403"
														:clear-on-select="true"
														label="label"
														open-direction="bottom"
														:hide-selected="true"
														track-by="value"   
														@select="updateAssignedMember(presentSubTask.assignee)" 
														:searchable="true"
														:hideArrow="false"
														placeholder="Assigned-To"
														deselectLabel=""
														selectLabel=""
														class="custom-multiselect userSelect"
														:class="{
															'has-options': userOptions && userOptions.length > 0,
															'no-options': !userOptions.length &&  searchValue !== '',
														}"
													>
														<template v-slot:noResult>
															<span>No Members Found</span>
														</template>
													</multiselect> -->
													<AutoComplete 
														v-model="presentSubTask.assignee"
														:suggestions="userOptions"
														@complete="asyncFind"
														@item-select="updateAssignedMember(presentSubTask.assignee)" 
														:disabled="presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420 || isAddDisabled(10302)"
														optionLabel="label"
														optionValue="value"
														placeholder="Assigned-To"
														class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
														:class="{
															'has-options': userOptions && userOptions.length > 0,
															'no-options': !userOptions.length &&  searchValue !== '',
														}"
													>
													<template #empty>
														<div class="text-sm">
															<span>No Members Found</span>
														</div>
													</template>
													</AutoComplete>
												</div>
											</div>
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Created By</label><br>
											<!-- show process Owner -->
											<div class="my-1">{{ getPersonName(presentSubTask.createdBy) }}</div>
										</div>
										<div class="mb-3">
											<!-- <label class="controllabel mb-2">Start Date</label><br>
											<div class="my-1">{{ formatDate(presentSubTask.startDate)}}</div> -->
											<!-- show Start Date -->
											<div>
												<label class="controllabel">Start Date</label>
												<input
													type="date"
													v-model="presentSubTask.startDate"
													class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
													@focus="openCalendar"
													onkeydown="return false"
													placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403"
													:max="presentSubTask.dueDate"
													@change="updateDate(presentSubTask.startDate,20604)"
												/>
                                        	</div>
										</div>
										<div class="mb-3">
											<!-- <label class="controllabel mb-2">Due Date</label><br> -->
											<!-- show Due Date -->
											<!-- <div class="my-1">{{ presentSubTask.dueData }}</div> -->
											<!-- <div v-if="(presentSubTask.dueDate!= undefined || presentSubTask.dueDate!= null ) && presentSubTask.dueDate!=''" class="my-1">{{ formatDate(presentSubTask.dueDate) }}</div>
											<div v-else class="my-1">N/A</div> -->
											<div>
                                                <label class="controllabel">Due Date</label>
                                                <input
                                                    type="date"
                                                    v-model="presentSubTask.dueDate"
                                                    class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
                                                    @focus="openCalendar"
                                                    onkeydown="return false"
                                                    placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403"
                                                    :min="presentSubTask.startDate"
                                                    @change="updateDate(presentSubTask.dueDate,20605)"
                                                />
                                            </div>
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Completion Date</label><br>
											<!-- show Start Date -->
											<!-- <div class="my-1">{{ formatDate(presentSubTask.completedAt)}}</div> -->
											 <input
													type="date"
													v-model="presentSubTask.completedAt"
													class="mt-2"
													@focus="openCalendar"
													:min="presentSubTask.startDate"
													placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403"
													@change="updateCompletionDate(presentSubTask.completedAt)"
													:class="{'inputboxstylingForSelectAtPopup': presentSubTask.startDate === '','stylingForInputboxstylingForSelectAtPopup': presentSubTask.startDate !== ''}"
												/>
												<!-- <div v-if="v$.presentSubTask.completedAt.$error" class="text-red-500">
													<div class="error-text" v-if="v$.presentSubTask.completedAt.required.$invalid">Required</div>
												</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Team</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{presentSubTask.departments }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Tier</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getTargetTitle(presentSubTask) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Scope</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getTargetInfo(presentSubTask) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<popup v-if="importpopUp" :popUp="importpopUp">
			<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
			<!--content-->
			<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
				<!--header-->
				<div class="flex items-center justify-between popupheadingcontainer rounded">
				<h1>Import files</h1>
				<button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCancelIcon()">
					<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
				</button>
				</div>
				<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
				<div class="impactcontainer popupbodycontainer flex-1 overflow-y-auto">
				<div class="formcontainer flex flex-col h-full">
					<div class="flex-1 overflow-auto hide-scrollbar">
						<div class="row flex flex-col mt-2">
						<div>
							<label class="controllabel">File Name </label>
							<input class="inputboxstyling mt-2" type="text" v-model.trim="inputFileName" placeholder="Filename" @input="v$.inputFileName.$touch()"  :class="{'is-invalid': v$.inputFileName.$error }"/>
							<div v-if="v$.inputFileName.$error " class="text-red-500">
								<div class="error-text text-xs" v-if="v$.inputFileName.required.$invalid ">Required</div>
								<div v-else-if="v$.inputFileName.required && v$.inputFileName.restrictCharacters30.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
							</div>
						</div>
						<div class="pt-3">
							<label class="controllabel">Attachment</label>
							<div class="mt-2 w-auto evidenceHeight bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden " :class="{'is-invalid':v$.fileToUpload.$error}">
								<!-- <label htmlFor="upload" class="controllabel">Upload File</label> -->
								<input type="file" placeholder="Choose a file to upload" ref="fileInput" class="hidden" id="upload" @change="handleFileUpload"/>
								<label for="upload" class="cursor-pointer">
									                          <div class="float-right text-white flex justify-center heightForDiv items-center w-9 bg-primary"><img src="@/assets/folderBrowseIcon.svg" /></div>
								<!-- <div v-if="fileName" class="text-xs p-1">{{ fileName }}</div> -->
								<div v-if="fileName == ''" class="text-sm text-mediumGrey heightForDiv">
									{{ placeholder }}
								</div>
								<div v-if="fileName != ''" class="text-sm heightForDiv">
									{{ fileName }}
								</div>
								</label>
							</div>
						</div>
						
						<div v-if="v$.fileToUpload.$error" class="text-red-500">
							<div v-if="v$.fileToUpload.$invalid" class="error-text text-xs">File upload is required</div>
						</div>
						</div>
					</div>
					<div>
					<div class="border-b border-solid border-lightgrey"></div>
					<div class="buttonposition flex justify-end items-center pt-4">
						<button class="btnprimary" @click="handleFileChange" :class="(inputFileName.length == 0) ? 'btndisabled pointer-events-none ' : 'btnprimary'">Save</button>
					</div>

					</div>
				</div>
				</div>
				<!--footer-->
			</div>
			</div>
			</div>
		</popup>
		<popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
			<template v-slot:header>
				<div class="flex items-center justify-between popupheadingcontainer rounded">
					<h1>Approval</h1>

					<button class="float-right text-3xl" @click="onCrossbtn()">
						<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
					</button>
				</div>
			</template>

			<div class="popup-business flex-1 overflow-y-auto">
				<div class="flex flex-col h-full ">
					<div class="flex-1 overflow-auto hide-scrollbar">
						<div>
							<div class="statuscontainer px-5 pb-5">
								<div class="formcontainer flex flex-col">
									<div class="row flex flex-row upperspacing">
										<div class=" w-1/2">
											<label class="controllabel">Name of the Authority</label>
											<div>
											<!-- <multiselect
												v-model="taskObj.approver"
												:options="authorityOptions"
												:showNoOptions="false"
												@search-change="asyncFind1"
												:limit-text="limitText"
												:multiple="false"
												label="label"
												open-direction="bottom"
												track-by="value"
												:searchable="true"
												:hideArrow="false"
												placeholder="Assigned-To"
												deselectLabel=""
												selectLabel=""
												class="custom-multiselect userSelect"
												:class="{
													'is-invalidmultiselect': v$.taskObj.approver.$error,
													'has-options': userOptions && userOptions.length > 0,
													'no-options': !userOptions.length &&  searchValue !== '',
												}"
											></multiselect> -->
											<AutoComplete
												v-model="taskObj.approver"
												:suggestions="authorityOptions"
												@complete="asyncFind1"
												optionLabel="label"
												optionValue="value"
												field="label"
												appendTo="self"
												:forceSelection="false"
												placeholder="Assigned-To"
												class="p-inputtext-sm systemsstyling"
												:class="{
													'p-invalid':  v$.taskObj.approver.$error,
													'has-options': authorityOptions && authorityOptions.length > 0,
													'no-options': !authorityOptions.length &&  searchValue !== '',
												}"
											/>
											
										</div>
										<div v-if="v$.taskObj.approver.$error " class="text-red-500">
											<div class="error-text" v-if="v$.taskObj.approver.$invalid ">Required</div>
										</div>
											
										</div >
									</div>
									<div class="row flex flex-row upperspacing">
										<div class="w-full">
											<label class="controllabel">Justification or Comments for Approving</label>
											<textarea
												class="inputboxstyling mt-2"
												placeholder="Comments"
												v-model.trim="taskObj.approvalComments"
												:class="{'is-invalid': v$.taskObj.approvalComments.$error }"
											/>
											<div v-if="v$.taskObj.approvalComments.$error " class="text-red-500">
												<div class="error-text" v-if="v$.taskObj.approvalComments.$invalid ">Required</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="border-b border-solid border-lightgrey mx-5"></div>
						<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
							<button class="btnprimary mr-1.5" :class="(JSON.stringify(taskObj) == JSON.stringify(taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="onCancelbtnAtApproval()">Reset</button>
							<button class="btnprimary" :class="(JSON.stringify(taskObj) == JSON.stringify(taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="clickOnSaveForApproval(taskObj)">Save</button>
						</div>

					</div>
				</div>
			</div>
		</popup>
	</div>
</template>
<style scoped>
.widthForCommentBox{
	width : 75px;
}
.w-20{
	width: 20%;
}
.w-80{
	width: 80%;
}
.attachmargin{
	margin-bottom : 2.5px;
}
.progressbarB {
	border: 2px solid var(--color-lightgrey);
	background: var(--color-lightgrey);
	position: relative;
	top: -8px;
	z-index: 1;
}
.numberBorder{
    border-top: 1px solid var(--color-lightgrey);
    border-right: 1px solid var(--color-lightgrey);
    border-bottom: 1px solid var(--color-lightgrey);
}
.numberNavy{
    border-left: 2px solid var(--color-primary);
    /* border-width: 2px; */
}
.progress {
	background: var(--color-primary);
	position: relative;
	border-radius: 4px;
	z-index: 2;
}
.primaryBackground{
	background-color: var(--color-primary)
}
.descriptionToggle {
	height: 97%;
}
.tabStructure {
	height: calc(100vh - 165px);
}
.thirtyWidthToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.thirtyWidthToggle{  
     height:  calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}
.descriptionToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.heightFixing {
	height:  calc(100vh - 220px);
	/* height : 64vh; */
}
option {
	background-color: #ffffff;
	color: #000000;
	border-color: pink transparent transparent transparent;
}
.textColorWhite {
	color: white;
}
.custom-select {
    background-image: url("../assets/collapseIcon.svg") !important;
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 12px 12px;
    background-position: right 15px center; /* Change the px value here to change the distance */
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}
.marginBottomForDoc{
	margin-bottom : 3px;
}
.marginTopForDoc{
	margin-top : 2.5px;
}
.marginBottomZero{
	margin-bottom : 0px;
}
.pendingEvidence{
    background-color: #8600f040;
}
.evidenceUpload{
    background: rgba(21,39,60,0.24);
}
.labelWidth{
	min-width: 7rem;
}
.framework{
	padding: 12px 170px 12px 12px;
}
.findingCategory{
	padding: 12px 80px 12px 12px;
}
.taskstatusboxstyling {
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color:var(--color-lightgrey);
  --tw-bg-opacity: 1;
  /* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  /* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}

.approvalbtndisabled {
	    height: 28px;
    border-radius: 4px;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color:var(--color-lightgrey);
    --tw-bg-opacity: 1;
    background-color:var(--color-lightgrey);
    padding-left: 20px;
    padding-right: 20px;
    /* font-family: Open Sans; */
    font-size:14px;
    font-weight: 700;
    line-height: 12px;
    --tw-text-opacity: 1;
    color: rgb(77 77 77 / var(--tw-text-opacity));
}
.evidenceHeight{
	height: 29px;
}
.heightForDiv{
  height : 29.333px;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.sendapprovalheight{
	height: 40px;
}
:deep(.p-select-dropdown){
  display: none !important;
}
:deep(.p-tab){
  padding: 0px 0px 5px 0px !important;
}
:deep(.p-tabpanels){
  padding-top:5px !important ;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow{
  background-color: #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen{
  background-color: #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen{
  background-color: #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred{
  background-color: #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error{
  background-color: #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
  font-weight: 600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import { helpers, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import popup from '@/components/popup.vue';
import tableData from '@/components/tableData.vue';
// import { groupBy } from 'lodash';
import { emitter, toast } from '@/main';
// import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import commentsEditor from '@/components/commentsEditor.vue';
import Multiselect from 'vue-multiselect';
import CommentsEditor from '@/components/commentsEditor.vue';
import safeHtml from '@/components/safeHtml.vue';
import dotsloader from '@/components/dotsloader.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import AutoComplete from 'primevue/autocomplete';
import Select from 'primevue/select';
const restrictCharacters30 = helpers.regex(/^.{0,30}$/);
export default defineComponent({
	data(): any {
		return {
			v$: useVuelidate(),
			selectedTabIndex: 1,
			fileToUpload: null,
			tabHead: [
				{ displayName: 'Description', id: 1 },

				{ displayName: 'Documents', id: 2 },

				{ displayName: 'Evidence', id: 3 },

				{ displayName: 'Approvals', id: 4 },

				{ displayName: 'Comments', id: 5 },

				{ displayName: 'History', id: 6 }
			],
			selectedTabObj:{},
			dummySubTask:{},
            clickOnButton: false,
			presentSubTask:[],
			dummyPresentSubTask:[],
			Headers: ['ccid','title','team','startDate','dueDate','SubTaskStatus'],
			tableRow:[],
			importpopUp: false,
			inputFileName: '',
			dotsLoader:false,
			fileName:'',
			isInputFileNameValid: true,
			showSubTaskPopUp: false,
			controltitle:'',
			activitiesList:[],
			allProjects:[],
			TaskDetailsDropDown: {
				taskStatus: '',
				assignedToDropDown: ''
			},
			// controlFrequencyArray: [
			// 	{ label: 'Daily', id: 1 },
			// 	{ label: 'Weekly', id: 2 },
			// 	{ label: 'Monthly', id: 3 },
			// 	{ label: 'Quarterly', id: 4 },
			// 	{ label: 'Semi Annualy', id: 5 },
			// 	{ label: 'Annualy', id: 6 },
			// 	{ label: 'Transactional', id: 7 },
			// ],
			
			taskObj:{
				approver:'',
                approvalComments : ''
            },
			taskObjDummy:{
				approver:'',
                approvalComments : ''
			},
			userOptions:[],
			routesArray:[],
			allSubTasks:[],
			optionsProjectArray:[],
			users:[],
			showApprovalPopup: false,
			SubTaskStatus:[
                // {
				// 	id: 10411,
				// 	value: 'Draft'
				// },
				{
					id: 10401,
					value: 'Open'
				},
				{
					id: 10402,
					value: 'In Progress'
				},
				// {
				// 	id: 10415,
				// 	value: 'In Review'
				// },
				// {
				// 	id: 10403,
				// 	value: 'Completed'
				// },
			],
			failed:[
				{
					id: 10420,
					value: 'Failed'
				}
			],
			inreview:[
			{
					id: 10415,
					value: 'In Review'
				}
			],
			SubTaskStatus1:[
				// {
				// 	id: 10401,
				// 	value: 'Open'
				// },
				// {
				// 	id: 10402,
				// 	value: 'In Progress'
				// },
				// {
				// 	id: 10415,
				// 	value: 'In Review'
				// },
				{
					id: 10402,
					value: 'In Progress'
				},
				// {
				// 	id: 10415,
				// 	value: 'In Review'
				// },
				{
					id: 10403,
					value: 'Completed'
				},
			],
			tasksStatus:[
				{
					id: 10411,
					value: 'Draft'
				},
				{
					id: 10401,
					value: 'Open'
				},
				{
					id: 10402,
					value: 'In Progress'
				},
				{
					id: 10415,
					value: 'In Review'
				},
				{
					id: 10415,
					value: 'In Review'
				},
				{
					id: 10403,
					value: 'Completed'
				},
			],
			subTaskDetailsObj:{},
			oldComments: true,
			newHistory: true,
			comment: '',
			comments: [],
			btnDisabled: true,
			selectedOption: '',
			selectedBG: '',
			workLogObject: [],
			optionsUserArray: [],
			orgUsersList: [],
			presentAuditObject: {},
			teamName: '',
			personObj : '',
			controlsArray : [],
			controlDetailsArray : [],
            controlsArrayAllControls : [],
            controlsDetailsList : [],
			teamObj : '',
			allFrameWorkControls:[],
			locationObject:[],
			fileSelected: false,
			isFileValid: true,
			fileChanged : false,
			findingsForTask:[],
			allActiveControls:[],
			teamObject:[],
			presentTemplateTask:[],
			approvingMembers:[],
			titleLength: 0,
            controlTitleLength:0,
			placeholder: 'Select a File',
			searchValue:'',
			authorityOptions:[],
			linkedControlDetails:[],
			allProcess:[],
			optionsActivityArray:[],
			allSystems:[],
			optionSystemArray:[]
		};
	},
	validations() {
		return {
			inputFileName:{required,restrictCharacters30},
			fileToUpload: { required },
			taskObj:{
				approver:{required},
				approvalComments:{required}
			}
		};
	},
	components: {
		breadCrumbs,
		popup,
		Multiselect,
		tableData,
		commentsEditor,
		safeHtml,
		dotsloader,
		Tabs,
		TabList,
		Tab,
		TabPanels,
		TabPanel,
		AutoComplete,
		Select
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo',dbPriority: 'dbPriority',dbFrequency:'dbFrequency'}),
	},
	methods: {
		limitText (count:any) {
			// console.log('countcount',count)
		},
		isAddDisabled(permission:any) {
            try {
                if (this.userInfo.organisationType !== 10701) {
                    return false; // or true if you want to disable for others
                }
				
                return !this.hasPermission(this.userInfo, 10007, 10117, permission);
            } catch (e) {
                console.error("Permission check failed:", e);
                return true; // safest fallback = disable the button
            }
	    },
		isAddApprovalDisabled(permission:any) {
            try {				
                if (this.userInfo.organisationType !== 10701 && (this.userInfo._id==this.presentSubTask.assignee.value || this.userInfo.roleId!=10217)) {

                    return false; // or true if you want to disable for others
                }
				
                return !this.hasPermission(this.userInfo, 10007, 10117, permission);
            } catch (e) {
                console.error("Permission check failed:", e);
                return true; // safest fallback = disable the button
            }
	    },
        hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
		if (!userInfo || !userInfo.apps) return false;

		const app = userInfo.apps.find((a:any) => a.appId === appId);
		if (!app) return false;

		const entity = app.entities?.find((e:any) => e.entityId === entityId);
		if (!entity) return false;
		
		return entity.permissions?.includes(permissionId) || false;
	    },
		changeDateFormat(date: any) {
            if(date != undefined){
                return date.split('-').reverse().join('-');
            }
		},
		async updateDate(updatedDate:any,type:any){
            let now = new Date();
            let selectedDate = new Date(updatedDate);
            selectedDate.setHours(
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );
            if(type==20604){
                let payload: any = { startDate: selectedDate};
                await this.updateTemplateTask(8,payload,type)
            }
            if(type==20605){
                let payload: any = { endDate: selectedDate};
                await this.updateTemplateTask(8,payload,type)
            }
 
        },
		getTargetTitle(data:any){
			if (data.activityId) {
				let Title = 'Activity';
				return Title
			} else if (data.systemId) {
				let Title = 'System';
				return Title
			}else if (data.projectId) {
				let Title = 'Project';
				return Title
			}else {
				return 'N/A'
			}
		},
		getTargetInfo(data:any){
			if(data.activityName){
				// let activity = this.optionsActivityArray.find((activity:any)=>data.activityId.toString()== activity.value.toString());
				return data.activityName!=undefined?data.activityName:'N/A'
			}
			else if(data.systemName) {
				// let System = this.optionSystemArray.find((sys:any)=>data.systemId.toString()== sys.value.toString());
				return data.systemName!=undefined?data.systemName:'N/A'			
			}
			else if(data.projectName) {
				// let System = this.optionsProjectArray.find((sys:any)=>data.projectId.toString()== sys.value.toString());
				return data.projectName!=undefined?data.projectName:'N/A'			
			}
			else{
				return 'N/A'
			}
		},
		getUserteamName(data:any){
			// let users =this.orgUsersList.find((u:any)=>u._id.toString() == data?.value);
			if(data!=undefined){
				if(data!=undefined){					
					let d = this.teamObject.find((dept:any)=>dept.value.toString()==data.toString());					
					 return d?d.label:'N/A'
				}
				else{
					return 'N/A'
				}
				// return users.departmentId
			}
			else{
				return 'N/A'
			}
		},
		asyncFind(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionsUserArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
		asyncFind1(query:any){
			query=query.query;
			this.searchValue = query;
			if(query == ''){
				this.authorityOptions = []
			}else if(query.length > 0){
				this.authorityOptions = this.approvingMembers?.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase()) && obj.value != this.userInfo._id})
			}
		},
		async getSubTaskHistoryObject() {
			// /api/org/task/:taskId/history/get
			
			// for task history
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.$route.params.subtaskId}/history/get`).then((result: any) => {
				const mainObject = result.data;
				this.workLogObject = mainObject;
				// if(this.workLogObject.taskHistory && this.workLogObject.taskHistory.length != 0){
				// 	this.workLogObject.taskHistory.sort().reverse();
				// }
			});
		},
		
		async fetchActivitiesList() {
		await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/processes/mappedcontrols/count`).then((res: { data: any }) => {
			this.activitiesList = res.data;
		});
		},
		async getAllProjects(){
			this.projectDataArray = [],
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((res: any) => {
				this.allProjects = res.data;
				for (var i = 0; i < this.allProjects.length; i++) {
					this.optionsProjectArray.push({ label: this.allProjects[i].projectName, value: this.allProjects[i]._id });
				}
		})},
		
		getLocation(teamId:any){
                
			let presentteamObject:any = this.users.find((obj: any) => {
				return obj._id == teamId;
			});

			if (presentteamObject!=undefined && presentteamObject.type == 20301){
				return 'Global';
			}else{
				if(this.presentSubTask.location == undefined || this.presentSubTask.location == null ){
					return 'N/A'
				}else{
					return this.getLocationName(this.presentSubTask.location[0].entity)
				}
			}
		},
		getLocationName(locationId: any) {
            let locationObj = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
			
            if (locationObj == undefined) {
                let empty = '';
                return empty;
            } else {
                return locationObj.label;
            }
        },
		sanitizeUrl(rawUrl: any) {
			if (typeof rawUrl !== 'string') {
				return '#';
			}
			const trimmed = rawUrl.trim();
			const lower = trimmed.toLowerCase();
			// Block dangerous schemes
			if (lower.startsWith('javascript:') || lower.startsWith('data:') || lower.startsWith('vbscript:')) {
				return '#';
			}
			// Allow http(s) and common relative URLs
			if (/^(https?:\/\/|\/|\.{1,2}\/)/.test(trimmed)) {
				return trimmed;
			}
			return '#';
		},
		async removeEvidence(evidenceIndex: number) {
			const evidence = this.presentSubTask?.evidences?.[evidenceIndex];
			const url = evidence?.url;
			try {
				const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
				if (fileResponse.status == 200 && fileResponse.data?.deleted === true) {
					await this.$http.post(
						`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.$route.params.subtaskId}/evidence/remove`,
						{ evidenceIndex }
					);
					await this.getPresentSubTask();
				}
			} catch (err) {
				toast.error(`Failed to remove evidence`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		onCancelIcon(){
			this.importpopUp = false
			this.inputFileName = ''
			this.fileName = ''
			this.fileToUpload=null
			this.v$.$reset();
		},
		getStatusLabel(num:any){
			let result:any;
			result = this.tasksStatus.find((obj:any)=>{return obj.id == num});	
			if(result==undefined){
				result = this.failed.find((obj:any)=>{return obj.id == num});	
			}		
			let resultValue = result.value
			return result.value
		},
		scrollTabIntoView(tabId : any) {
			this.$nextTick(() => {
				const tabElement = this.$el.querySelector(`.tab:nth-child(${tabId})`);
				if (tabElement) {
				tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
				}
			});
		},
		openApprovalpopup(){
			this.showApprovalPopup = true
		},
		onCancelbtnAtApproval(){
			this.v$.$reset();
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
		},
		onCrossbtn(){
			this.v$.$reset();
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
			this.showApprovalPopup =  false
		},
		checkOwner(){
			let approver: any 
			if(this.presentSubTask.approvals){
				let approvals: any = this.presentSubTask.approvals
				approvals.forEach((obj:any) => {
					approver = obj.approver
				});
				if(this.userInfo.organisationType==10701 && this.userInfo.role_id!=10217){
					return true;
				}
				if(approver == this.userInfo._id || this.userInfo.roleId!=10217){
					return true
				} else{
					return false
				}
			}
		},
		async getAllActiveControls(){
			await this.$http
			.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`)
			.then((result: { data: any }) => {
				this.allActiveControls = result.data;
			}).catch((error: any) => {
				toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			});
        },
		clickOnSaveForApproval(obj: any){
			// (TYPE = 3) for sending approvals

			// {approver:'userId',createdBy:'',createdAt:''}
			let payload: any = {
				approver :obj.approver.value,
			}
			this.v$.$touch();
			if(!this.v$.taskObj.$invalid){
				this.clickOnButton = true;
			this.updateTemplateTask(3,payload)
			this.getPresentSubTask();
			this.taskObjDummy = this.taskObj
			this.showApprovalPopup = false
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
			this.v$.$reset();
			this.clickOnButton = false;
			}
		},
		async approveOrRejectTheParentApproval(statusCode: any){
			this.clickOnButton = true;
			let subtaskId: any = this.$route.params.subtaskId
			const payload: any={
				statusCode: statusCode,
				updatedBy: this.userInfo._id
			}
			// /api/org/task/:taskId/update/approval

			// POST

			// => payload for approving approval

			// {statusCode: 10403 , updatedBy:'',updatedAt:''}
			await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${subtaskId}/update/approval`,payload).then((res: any) => {
                
				// console.log("this.presentSubTask",this.presentSubTask)
            });
			if(statusCode == 10403){
                toast.success(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				await this.getSubTaskHistoryObject()
            }else if(statusCode == 10410){
                toast.error(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				this.clickOnButton = false;
				await this.getSubTaskHistoryObject() 
            }
			await this.getPresentSubTask();
			// this.workLogObject.taskHistory?.sort().reverse();
		},
		async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data;
				for (var i = 0; i < this.orgUsersList.length; i++) {
					this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });

					if(this.userInfo._id != this.orgUsersList[i]._id){
						this.approvingMembers.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
				}
			});
		},
		
		async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityName, value: result[i]._id });
            }
        },
		async getAllTeams() {
            this.teamObject = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
            
        },
		async getAllBusinessProcesses() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
				this.allProcess = result.data
            });
			for(let i=0;i<this.allProcess.length;i++){
				this.optionsActivityArray.push({ label: this.allProcess[i].businessProcessName, value: this.allProcess[i]._id });
			}
		},
		async getAllSystems(){
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20005}`).then((result: any) => {
				this.allSystems = result.data;
				// this.orgUsersList = res.data
				for (var i = 0; i < this.allSystems.length; i++) {
					this.optionSystemArray.push({ label: this.allSystems[i].systemName, value: this.allSystems[i]._id });
				}
			});
		},
		getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {             
				return user._id == person;
			});
			
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
		getPerson(person: any) {
			this.personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (this.personObj == undefined) {
				return '';
			} else {
				return this.personObj.name;
			}
		},
		sortWorkLog() {
			this.newHistory = !this.newHistory;
			this.workLogObject.taskHistory?.sort().reverse();
		},
		sortComments() {
			this.oldComments = !this.oldComments;
			if(this.presentSubTask.comments != undefined){
				this.presentSubTask.comments.sort().reverse();
			}
		},
		formatTime(time: any) {
			let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
		},
		formatDate(date:any) {
		if(date==undefined || date==''){
			return 'N/A'
		}
			let now = moment(date);
			return now.format('DD-MM-YYYY');
		},
		extractInitials(name: any) {
			if(name!=undefined){
			const names = name.split(" ");
			return names
			.map((name: any) => name[0])
			.join("")
			.toUpperCase();

			}
			else{
				return '';
			}
			
		},
		changeBackground() {
			if (this.TaskDetailsDropDown.taskStatus == 10411) {
				return 'bg-disabledgrey textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10415) {
				return 'bg-yellow textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10402) {
				return 'bg-electricGreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10403) {
				return 'bg-lightgreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10401) {
				return 'bg-primary textColorWhite';
			}else if (this.TaskDetailsDropDown.taskStatus == 10420) {
				return 'bg-darkred textColorWhite';
			} else {
				return '';
			}
		},
		checkAuditor(id:any){
			if(id == this.userInfo._id){
				return true
			} else if(id == undefined || id == null){
				return false
			} else {
				return false
			}
		},
		async updateTaskStatus(status: any) {          
            if(this.presentSubTask!=undefined && this.presentSubTask.statusCode!=undefined && status!=undefined && this.presentSubTask.statusCode==status) {
                return;
            }
            let payload: any = { statusCode: status };
            if(status == 10403){                                
                let hasCompletedAt = (
                    this.presentSubTask!=undefined &&
                    this.presentSubTask.completedAt != undefined &&
                    this.presentSubTask.completedAt != ""
                );
                let hasEvidence = (
                    this.presentSubTask.evidences != undefined &&
                    this.presentSubTask.evidences != null &&
                    this.presentSubTask.evidences.length > 0
                );
                if(!hasCompletedAt && !hasEvidence){
                    this.$nextTick(() => {
                        this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                    });
                    toast.error(`Add Evidence and Completion Date`, {
                        timeout: 3000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true,
                    });
                    return;
                }
                if(!hasCompletedAt){
                    this.$nextTick(() => {
                        this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                    });
                    toast.error(`Add Completion Date`, {
                        timeout: 3000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true,
                    });
                    return;
                }
                if(!hasEvidence){
                    this.$nextTick(() => {
                        this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                    });
                    toast.error(`Add Evidence`, {
                        timeout: 3000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true,
                    });
                    return;
                }
 
                if(hasEvidence && hasCompletedAt){
                    await this.updateTemplateTask(5,payload)
                }
            }
            else {
                await this.updateTemplateTask(5, payload);
            }
        },
		async updateAssignedMember(obj: any) {
			let payload: any = { assignee: obj.value };
			await this.updateTemplateTask(6,payload)
		},
		async updateCompletionDate(obj:any) {
			let payload:any= {completedAt: obj };
			await this.updateTemplateTask(8,payload);
		},
		handleInput() {
			this.btnDisabled = this.comment.length === 0;
		},
		async addComment() {
			if (this.comment.trim() !== '') {
				const newComment: any = {
					comment: this.comment
				};
				await this.updateTemplateTask(4, newComment);
				
				// if(this.presentSubTask.comments != undefined){
				// 	this.presentSubTask.comments.sort().reverse();
				// }
				this.comment = '';
				this.btnDisabled = true;
			}
		},
		clearComment() {
			this.comment = '';
			this.btnDisabled = true;
		},
		async toggleTabs(obj: any) {
			this.dotsLoader=true
			this.scrollTabIntoView(obj.id);
			this.selectedTabIndex = obj.id;
			this.selectedTabObj = obj;
			// sessionStorage.setItem('selectedTab',obj.id);			
			await this.getPresentSubTask();
			
			await this.getSubTaskHistoryObject();
		},
		colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
        getProirityLabel(val:any){
          if (val === 'N/A') { 
              return ''; 
          } else {
              let a = this.dbPriority.find((obj: any) =>{
			  return obj.value == val});
              return (val && typeof val === 'number') ? a.key : '';
          }

        },
		onCancelButtonAddPopUp() {
			this.showSubTaskPopUp = false;
			this.onCancelbtn();
		},
		openFilePopup() {
			this.importpopUp = true
		},
		updateFileName(event: any) {
			let file = this.$refs.fileInput.files[0];

			if (file && !file.type.match('application/pdf') && !file.name.endsWith('.doc') && !file.name.endsWith('.docx')) {
				alert('Please select a PDF, DOC, or DOCX file.');
				return;
			} else {
				this.fileChanged = true;
				this.fileToUpload.file = file;
			}
		},
		handleFileUpload(event: any) {
            const file = this.$refs.fileInput.files[0];
            if (file) {
                this.fileName = file.name;
                this.fileToUpload = file
               
                const fileNameParts = file.name.split('.');
                
                fileNameParts.pop();
                const nameWithoutExtension = fileNameParts.join('.');
                
                if (this.inputFileName.trim() === '') {
                	this.inputFileName = nameWithoutExtension;
                }
            } else {
                this.fileName = '';
                this.inputFileName = '';
            }
        },
		async handleFileChange(event: any) {
			let data = this.$refs.fileInput.files[0];
			
			this.v$.inputFileName.$touch()
			this.v$.fileToUpload.$touch()
			
			if((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid)){
				this.importpopUp = !this.importpopUp
				let fileExtension = data.name.split('.').pop();

				if (fileExtension == 'pdf') {
					const fileDataFormat = await this.getConvertDataForFile(data);
					let uuid = uuidv4();
					let payload = { fileData: fileDataFormat, name: `${uuid}.${fileExtension}` };
					let folderName = `${process.env.VUE_APP_PLANNER_FOLDER_NAME}`;
					try {
						await this.$http
							.post(`${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`, payload)
							.then(async (response: any) => {
								if (response.status == 200) {
									let payload: any = {
										// name: `${uuid}.${fileExtension}`,
										url: response.data,
										filename:this.inputFileName
									};
									await this.updateTemplateTask(2, payload);
									this.inputFileName = ''
									this.fileName = ''
									this.v$.$reset();
								} else {
									// console.log('response status', response.status);
								}
							});
					} catch (err) {
						console.error(err);
					} finally {
						this.clickOnButton = false;
					}
				} else {
					toast.error(`Upload only pdf`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
					this.v$.$reset();
				}
				
				this.fileName = '';
				this.inputFileName = '';
				this.fileToUpload=null
			}
		},
		async getConvertDataForFile(data: any) {
			return new Promise((resolve) => {
				const reader: any = new FileReader();
				reader.onload = function () {
					resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
				};
				reader.readAsDataURL(data);
			});
		},
		
		async getPresentSubTask() {
			this.dotsLoader = true
            let subtaskId:any = this.$route.params.subtaskId
			// /api/org/task/:taskId/get

            // GET

            // for getting one task object 
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${subtaskId}/get`).then((res: any) => {
                this.presentSubTask = res.data;
            });
			
			// this.controltitle= this.allActiveControls.find((obj: any)=>{return obj._id == this.presentSubTask.control})
			
			this.teamName = this.teamObject.find((obj: any)=>{return obj.value == this.presentSubTask.team})
			this.linkedControlDetails = this.presentSubTask.controlDetails;	

            this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
			if(this.presentSubTask.assignee != undefined){
				// let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentSubTask.assignee});
				this.presentSubTask.assignee = this.presentSubTask.assigneeName;
			}else{
				let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentSubTask.auditor});
				this.presentSubTask.assignee = this.presentSubTask.assigneeName;
			}
			if(this.presentSubTask!=undefined && this.presentSubTask.hasOwnProperty('departmentName') && this.presentSubTask.departmentName!=undefined) {				
				this.presentSubTask.departments = this.presentSubTask.departmentName
			}
			this.dotsLoader = false
			this.dummyPresentSubTask = {...this.presentSubTask};			
			if(this.presentSubTask !=undefined && this.presentSubTask.completedAt!='' && typeof this.presentSubTask.completedAt=='string'){
				this.presentSubTask.completedAt = moment(this.presentSubTask.completedAt).format('YYYY-MM-DD')

			}
			if(this.presentSubTask.startDate!=undefined && this.presentSubTask.startDate!=''){
                this.presentSubTask.startDate=moment(this.presentSubTask.startDate).format('YYYY-MM-DD')
            }
            if(this.presentSubTask.dueDate!=undefined && this.presentSubTask.dueDate!=''){
                this.presentSubTask.dueDate=moment(this.presentSubTask.dueDate).format('YYYY-MM-DD')
            }
			
        },
		async getSingleActiveControl(){
			let controlId = this.presentSubTask?.control|| this.presentSubTask?.controlId;
			await this.$http
			.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/active/control/${controlId}/get`)
			.then((result: { data: any }) => {
				this.linkedControlDetails = result.data;	
			}).catch((error: any) => {
				toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			});
        },
		async updateTemplateTask(type: any, payload: any,dateType:any) {
			payload.createdBy = this.userInfo._id;
			payload.updatedAt=new Date();
			payload.updatedBy = this.userInfo._id;
			payload.additionalInfo = [];
            let now = new Date();

			if(type == 2){
				payload.additionalInfo = {evidence:''};
				payload.additionalInfo.evidence = payload.filename;
			} else if(type == 3){
				payload.additionalInfo = {approver:''};
				payload.additionalInfo.approver = payload.approver;
			} else if(type == 4){
				payload.additionalInfo = {comment:''};
				payload.additionalInfo.comment = payload.comment;
			} else if(type == 5){
				payload.additionalInfo = {previousStatus:'',updatedStatus:''};
				payload.additionalInfo.previousStatus = this.presentSubTask.statusCode;
				payload.additionalInfo.updatedStatus = payload.statusCode;
				if(this.presentSubTask.hasOwnProperty('isActiveControlTask') && this.presentSubTask.isActiveControlTask == true){
					payload.dueDate = moment(new Date());
				}				
			} else if(type == 6){
				payload.additionalInfo = {assignee:''};
				payload.additionalInfo.assignee = payload.assignee;
			} else if(type == 7){
				payload.additionalInfo = {createdBy:''};
				payload.additionalInfo.createdBy = payload.createdBy;
			} else if(type == 8){
				if (dateType == 20604) {
                    let selectedStartDate = new Date(this.dummySubTask.startDate);
					selectedStartDate.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
                    payload.additionalInfo.push({
                        previousStartDate: selectedStartDate,
                        updatedStartDate: payload.startDate,
                        dateId: 20604
                    });
                }
				if(payload.completedAt && payload.completedAt!='') {
					let now = new Date();
					payload.completedAt = new Date(payload.completedAt);
					payload.completedAt.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
					if(this.dummyPresentSubTask.completedAt && this.dummyPresentSubTask.completedAt!=''){
						this.dummyPresentSubTask.completedAt = new Date(this.dummyPresentSubTask.completedAt);
					this.dummyPresentSubTask.completedAt.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
					}
					
					payload.updatedAt = new Date().toISOString();				
					// this.dummyPresentSubTask.completedAt =  new Date(this.dummyPresentSubTask.completedAt)
					payload.updatedBy = this.userInfo._id;
					delete payload.createdBy;
					let additionalInfoArr:any=[];
					let additionalInfo:any={};
					additionalInfo.previousCompletionDate = this.dummyPresentSubTask.completedAt,
					additionalInfo.updatedCompletionDate = payload.completedAt
					additionalInfo.dateId = 20606
					additionalInfoArr.push(additionalInfo);
					payload.additionalInfo = additionalInfoArr
				}
				if (dateType == 20605) {
                    let selectedEndDate = new Date(this.dummySubTask.dueDate);
                    selectedEndDate.setHours(
                        now.getHours(),
                        now.getMinutes(),
                        now.getSeconds(),
                        now.getMilliseconds()
                    );
                    payload.additionalInfo.push({
                        previousEndDate: selectedEndDate,
                        updatedEndDate: payload.endDate,
                        dateId: 20605
                    });
                }
			}
			try {	
				// if (this.presentSubTask!=undefined &&this.presentSubTask!=''&&this.presentSubTask.startDate!=undefined&&this.presentSubTask.startDate&&
				// 	this.presentSubTask.dueDate==this.presentSubTask.startDate
				
				// ) {
				// 	toast.error(`Start date and Due date cannot be the same`, {
				// 			timeout: 1000,
				// 			closeOnClick: true,
				// 			closeButton: 'button',
				// 			icon: true
				// 		});
				// }
				// else{
					let result = await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.$route.params.subtaskId}/type/${type}/update`, payload).then(async (result: any) => {
						if(result.status==200 && payload.additionalInfo.updatedStatus==10403){
							let payload={taskId:this.$route.params.subtaskId};
							try{
							await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_CR_WORKFLOW_ID}/compliance/crTask`, payload).then(async (result: any) => {
								toast.info(`Updated`, {
									timeout: 1000,
									closeOnClick: true,
									closeButton: 'button',
									icon: true
								});
							});
							}
							catch{
								toast.error(`Error`, {
									timeout: 1000,
									closeOnClick: true,
									closeButton: 'button',
									icon: true
								});
							}
						}
						else{
							toast.info(`Updated`, {
									timeout: 1000,
									closeOnClick: true,
									closeButton: 'button',
									icon: true
								});
						}
					});
				// }
            } catch(error:any) {
				if(error.response && error.response.status==403) {
                            toast.error(`${error.response.data.error}`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                }
				else{
					toast.error(`Error`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
                	});	
				}
            }
			await this.getPresentSubTask();
			await this.getSubTaskHistoryObject();
			// this.workLogObject.taskHistory?.sort().reverse();
		},
		colorTemplateText(status: any) {
			if (status == 10411) {
				return ['font-semibold text-xs text-disabledgrey'];
			} else if (status == 10415) {
				return ['font-semibold text-xs text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-xs text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold text-xs mx-2 text-electricGreen']
			} else if(status == 10420){
				return ['font-semibold text-xs mx-2 text-darkred']
			} else if(status == 10401){
				return ['font-semibold text-xs mx-2 text-primary']
			} else{
				return 'N/A'
			}
		},
		colorTemplateBg(status: any) {
			if (status == 10411) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10401) {
				return ['bg-primaryBg border-solid border border-primary'];
			} else if (status == 10420) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}
		},
		getControlFrequency(id: any) {
			if (id !== undefined && id !== '' && id !== null) {
				let frequency: any = this.dbFrequency.find((data: any) => {return data.value == id});
				if (frequency && frequency.key !== undefined) {
					return frequency.key;
				} else {
					return 'N/A';
				}
			} else {
				return 'N/A';
			}
		},
		async getPresentTemplateTask() {
			let taskId : any = this.$route.params.taskId
			
            await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${taskId}/get`).then((res: any) => {
                this.presentTemplateTask = res.data;
            });
        },
		
		
	},
	async mounted(){
		emitter.off('addedComments');
		emitter.on('addedComments',(data: any)=>{
			this.comment = data.comments
			this.addComment()
		})
	},
	async created(){		
		this.dotsLoader=true
        await this.getAllActiveUsers();
		// await this.getAllTeams();
		// await this.getAllSystems();
		// await this.fetchActivitiesList();
		// await this.getAllProjects()
		// await this.getAllBusinessProcesses();
		// await this.getAllActiveControls();
        await this.getPresentSubTask();
		// await this.getSingleActiveControl();
		this.dummySubTask={...this.presentSubTask}
		// await this.getSubTaskHistoryObject();
		const savedTabKey = sessionStorage.getItem('selectedTab');

		if (savedTabKey) {
			const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
			if (savedTab) {
				await this.toggleTabs(savedTab);
			}else{
				this.selectedTabObj = { displayName: 'Description', id: 1 };
				this.selectedTabIndex = 1;
			}
        }else {
		    this.selectedTabObj = { displayName: 'Description', id: 1 };
			this.selectedTabIndex = 1;
		}
		this.dotsLoader=false;
		
		if(this.$route.query.tasks == 'true'){
			await this.getPresentTemplateTask();
			this.routesArray = [
				{ name: 'dummyTasks', routeName: 'dummyTasks' },
				{ name: this.presentTemplateTask.taskId, routeName: 'testTemplateTaskEdit' },
				{ name: this.presentSubTask.taskId, routeName: 'testSubTaskEdit' },
			];
		} else{
			this.routesArray = [
				{ name: 'dummyTasks', routeName: 'dummyTasks' },
				{ name: this.presentSubTask.taskId, routeName: 'testSubTaskEdit' },
			];
		}
		
		if(this.presentSubTask.comments != undefined){
			this.presentSubTask.comments.sort().reverse();
		}

		// this.workLogObject.taskHistory?.sort().reverse();
		this.titleLength = this.presentSubTask.TaskName ? this.presentSubTask.TaskName.length:0
        this.controlTitleLength = this.presentSubTask?.controlTitle ? this.presentSubTask?.controlTitle.length:0
	},
	beforeUnmount() {
		sessionStorage.removeItem('selectedTab')
	},
	
});
</script>
